import React from 'react';
import classNames from 'classnames';

import styles from './Table.module.scss';

interface TableProps {
  // style?: React.CSSProperties;
  // onClick?: (event: React.MouseEvent) => void;
  className?: string;
}

const Table: React.FC<TableProps & React.HTMLAttributes<HTMLTableElement>> = props => {
  const { children, className, ...restProps } = props;

  return (
    <table className={classNames(styles.table, className)} {...restProps}>
      {children}
    </table>
  );
};

export default Table;
